export interface JSONSchema {
  sys: JSONSchemaSys;
  total: number;
  skip: number;
  limit: number;
  items: Item[];
  includes: Includes;
}

export interface Includes {
  Entry: EntryElement[];
  Asset: Asset[];
}

export interface Asset {
  metadata: Metadata;
  sys: AssetSys;
  fields: AssetFields;
}

export interface AssetFields {
  title: string;
  description: string;
  file: File;
}

export interface File {
  url: string;
  details: Details;
  fileName: string;
  contentType: string;
}

export interface Details {
  size: number;
}

export interface Metadata {
  tags: any[];
  concepts: any[];
}

export interface AssetSys {
  space: Entry;
  type: string;
  id: string;
  revision: number;
  createdAt: Date;
  updatedAt: Date;
  publishedAt: Date;
  firstPublishedAt: Date;
  publishedVersion: number;
  environment: Entry;
  locale: string;
  contentType?: Entry;
}

export interface Entry {
  sys: EntrySys;
}

export interface EntrySys {
  id: string;
  type: Type;
  linkType: string;
}

export enum Type {
  Link = "Link",
}

export interface EntryElement {
  metadata: Metadata;
  sys: AssetSys;
  fields: EntryFields;
}

export interface EntryFields {
  internalName: string;
  title: string;
  slug: string;
  breadcrumbTitle: string;
  breadcrumbsColor: string;
  breadcrumbsPosition: string;
  breadcrumbsVariant: string;
  header: Entry;
  sideCtas: Entry;
  strips: Entry[];
  footer: Entry;
}

export interface Item {
  metadata: Metadata;
  sys: AssetSys;
  fields: ItemFields;
}

export interface ItemFields {
  internalTitle: string;
  slug: string;
  file?: Entry;
  entry?: Entry;
  externalUrl?: string;
}

export interface JSONSchemaSys {
  type: string;
}


export enum EQRResult {
    HAS_FILE, HAS_LINK, HAS_EXTERNAL_LINK, NONE
}

export type TResponseFetchQR ={
    data: EntrySys | string | null,
    status: EQRResult
}